import { useAtom } from 'jotai'
import * as React from 'react'
import styled from 'styled-components'
import { isEditProfileOpenAtom } from '../../../atoms/profile'
import { useFirebaseAuthGuard } from '../../../hooks/firebase'
import useAtomWithRef from '../../../utils/useAtomWithRef'
import { spacebarListenerActiveAtom } from '../../video/videoplayer/atoms'

// ============================ Styled components ==============================

const OuterDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 10px;
  padding: 5px 0;
  width: 100px;
  cursor: pointer;
  background: #fff;

  @media (min-width: 43em) {
    width: 140px;
  }
`

const Title = styled.div`
  color: black;
  font-weight: 700;
  display: flex;
  text-align: center;
  width: 100%;
  align-items: center;
  justify-content: center;
  font-size: 18px;

  // tablet
  @media (max-width: 62em) {
    font-size: 17px;
  }

  // mobile
  @media (max-width: 43em) {
    font-size: 15px;
  }
`

// ============================ React component ================================

const EditProfileButton = (): JSX.Element => {
  const [, setEditProfileOpen] = useAtom(isEditProfileOpenAtom)
  const [, , setSpaceBarActive] = useAtomWithRef(spacebarListenerActiveAtom)
  const openEditDialog = React.useCallback(() => {
    setEditProfileOpen(true)
    setSpaceBarActive(false)
  }, [setEditProfileOpen])

  const editProfile = useFirebaseAuthGuard(openEditDialog)

  return (
    <OuterDiv onClick={editProfile}>
      <Title>Edit</Title>
    </OuterDiv>
  )
}

export default EditProfileButton
